<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 26.284 24.035">
        <g id="Group_2728" data-name="Group 2728" transform="translate(-20 -199)">
            <g id="Group_2727" data-name="Group 2727" transform="translate(-2.485 -2.28)">
                <circle id="Ellipse_197" data-name="Ellipse 197" cx="12" cy="12" r="12"
                        transform="translate(22.485 201.28)" fill="#c0d0fc"/>
                <g id="translate" transform="translate(29.616 206.162)">
                    <path id="Path_70081" data-name="Path 70081"
                          d="M17.471,4.526H9.243L7.866.384A.561.561,0,0,0,7.334,0H1.685A1.685,1.685,0,0,0,0,1.683v11.26a1.685,1.685,0,0,0,1.683,1.683H7.869l1.366,4.131a.563.563,0,0,0,.536.4h7.7a1.685,1.685,0,0,0,1.683-1.683V6.21a1.685,1.685,0,0,0-1.683-1.683ZM1.685,13.5a.562.562,0,0,1-.561-.561V1.683a.562.562,0,0,1,.561-.561H6.929L11.045,13.5Zm9.267,1.122-1.1,2.426-.8-2.426Zm7.08,2.843a.562.562,0,0,1-.561.561h-6.83L12.334,14.3a.565.565,0,0,0,.021-.409L9.616,5.649h7.855a.562.562,0,0,1,.561.561Z"
                          transform="translate(-0.002 0)" fill="#799cfb"/>
                    <path id="Path_70082" data-name="Path 70082"
                          d="M66.052,123.244H64.369a.561.561,0,1,0,0,1.122h1.026a1.683,1.683,0,1,1-.4-1.751.561.561,0,0,0,.794-.794,2.806,2.806,0,1,0,.822,1.984A.561.561,0,0,0,66.052,123.244Z"
                          transform="translate(-58.72 -116.474)" fill="#799cfb"/>
                    <path id="Path_70083" data-name="Path 70083"
                          d="M306.052,212.122h-1.683v-.561a.561.561,0,1,0-1.122,0v.561h-1.683a.561.561,0,1,0,0,1.122h3.26a7.052,7.052,0,0,1-1.008,1.765c-.1-.13-.191-.262-.282-.4a.561.561,0,1,0-.928.631c.157.232.322.457.487.67-.28.325-.557.62-.8.858a.561.561,0,1,0,.786.8c.019-.019.325-.32.734-.783.4.456.7.756.721.779a.561.561,0,0,0,.794-.793c-.006-.006-.349-.351-.788-.863a7.3,7.3,0,0,0,1.446-2.669h.067a.561.561,0,0,0,0-1.122Z"
                          transform="translate(-289.742 -203.107)" fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ITranslate",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
